var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-wrap"},[_c('div',{staticClass:"monthly-payment-wrap"},[_c('PaymentPanel',{staticClass:"panel",attrs:{"sourceData":_vm.sourceData}})],1),_c('PaymentList',{staticClass:"list",attrs:{"dataList":this.$store.state.calcuRes[_vm.$route.query.type].group_detail,"mode":_vm.$route.query.mode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }